<template>
  <layout title="Face Matching Demo">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 max-w-7xl w-full md:flex items-start">
        <div class="relative w-full md:w-56" ref="sideMenu">
          <div
            ref="sideMenuAbsolute"
            class="
              relative
              md:absolute
              z-40
              w-full
              md:w-56
              hover:w-56
              bg-white
              rounded-t-xl
              md:rounded-b-xl
              rounded-b-none
              shadow-allArround
              md:py-6
              pt-4
              md:pb-4
              pb-0
              transition-all
              ease-out
              group-sideMenu
              md:px-0
              px-2
            "
          >
            <div class="mt-2 sm:ml-5 ml-0 font-black text-md block">
              EXAMPLES
            </div>
            <div class="flex md:flex-col flex-row md:mt-0 mt-2">
              <div
                class="
                  mt-2
                  w-full
                  h-10
                  relative
                  font-bold
                  flex
                  items-center
                  cursor-pointer
                  group
                  transition-all
                  duration-300
                  ease-out
                  focus:outline-none
                  md:pb-0
                  pb-2
                "
                :class="
                  activeSection == sec.id
                    ? 'text-primary-color hover:bg-primary-100 focus:bg-primary-100'
                    : 'text-gray-600 hover:text-gray-800 focus:text-gray-800 hover:bg-gray-100 focus:bg-gray-100'
                "
                v-for="(sec, index) in sections"
                :key="index"
                @click="changeSection(sec.id)"
              >
                <div
                  class="
                    absolute
                    left-0
                    md:w-0.5
                    bottom-0
                    w-full
                    transition-all
                    duration-300
                    ease-out
                    rounded-full
                  "
                  :class="
                    activeSection == sec.id
                      ? 'bg-primary-color md:h-full h-0.5'
                      : 'group-hover:bg-gray-300 md:h-full h-0.5 group-hover:h-full'
                  "
                ></div>
                <div class="flex sm:ml-5 ml-0">
                  <div
                    class="
                      transition-all
                      duration-300
                      ease-out
                      showSideMenu
                      w-full
                    "
                  >
                    {{ sec.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 md:ml-8 ml-0">
          <div
            class="
              font-black
              text-3xl text-gray-800
              inline-block
              lg:col-span-2
              col-span-1
              md:mt-0
              mt-4
            "
          >
            Face matching demo
          </div>
          <alertBox>
            We do not store any uploaded images in our databases.<br />
            In this demo will be used your API key.
          </alertBox>
          <div class="mt-4">
            <label class="mr-2">Select Liveness Algorithm:</label>
            <multiselect
              v-model="optionValue"
              :options="options"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :allowEmpty="false"
              class="max-w-max"
              style="display: inline-block"
            ></multiselect>
          </div>

          <div
            class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
          >
            <div class="p-4 text-gray-800 overflow-hidden bg-gray-50">
              <matchImages
                v-if="activeSection == Section.MatchImages"
                :option="optionValue"
              />
              <processImages
                v-if="activeSection == Section.ProcessImage"
                :option="optionValue"
              />
              <galleryIdent
                v-if="activeSection == Section.GalleryIdent"
                :option="optionValue"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");

const alertBox = () =>
  import(/* webpackChunkName: "alertBox" */ "../../Components/alertBox.vue");

import matchImages from "./FaceMatching.vue";
import processImages from "./ProcessImage.vue";
import galleryIdent from "./GalleryIdent.vue";

//enum
const Section = Object.freeze({
  MatchImages: 1,
  ProcessImage: 2,
  GalleryIdent: 3,
});

export default {
  components: { layout, alertBox, matchImages, processImages, galleryIdent },
  data() {
    return {
      Section,
      sections: [
        {
          id: Section.MatchImages,
          name: "Match Images",
        },
        {
          id: Section.ProcessImage,
          name: "Process Image",
        },
        {
          id: Section.GalleryIdent,
          name: "Gallery & Identification",
        },
      ],
      activeSection: Section.MatchImages,
      optionValue: "Default",
      options: ["Default", "Certified"],
    };
  },
  methods: {
    changeSection(section) {
      this.activeSection = section;
    },
  },
};
</script>